var Layout    = require("enyo-ui/Layout"),
    kind      = require("enyo/kind"),
    themeVars = require("app/theme/variables.js");

module.exports = kind(/** @lends  app.ui.HeaderGraphic.VideoGraphicLayout.prototype */ {

    /**
     * @private
     */
    name: "app.ui.HeaderGraphic.VideoGraphicLayout",

    /**
     * @private
     */
    kind: Layout,

    /**
     * The layout will expose some computed measurements here, for easy reuse by
     * nested components.
     *
     * @readonly
     * @public
     */
    metrics: null,

    /**
     * @public
     */
    reflow: function() {
        var $container    = this.container,
            layoutMetrics = $container.get("layoutMetrics") || {},
            $video        = $container.$.video,
            $topGradient  = $container.$.topGradient,
            videoWidth,
            videoHeight,
            topGradientHeight;

        if (!$container.hasNode()) {
            return;
        }

        // Resolve metrics
        videoWidth        = layoutMetrics.graphicWidth;
        videoHeight       = layoutMetrics.graphicHeight;
        topGradientHeight = Math.round(Math.min(8 * themeVars.remToPx, layoutMetrics.containerHeight * 0.382));

        // Apply metrics
        $video.addStyles({
            width:  videoWidth + "px",
            height: videoHeight + "px"
        });
        $topGradient.addStyles({
            height: topGradientHeight + "px"
        });

        // Toggle top gradient visibility
        switch (themeVars.formFactor) {
            case "medium":
            case "large":
                $topGradient.show();
                break;
            case "tiny":
            case "smaller":
            case "small":
            default:
                $topGradient.hide();
                break;
        }
    }

});
